<template>
  <div class="drag-drop-container" @drop.prevent="handleFileInput">
    <div class="file-upload-wrapper" v-show="!files.length">
      <form ref="form">
        <input
          type="file"
          name="file-input"
          multiple="True"
          @change="handleFileInput"
          ref="file-input"
        />
      </form>
      <div class="flex flex-col items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
        >
          <path
            id="icons8-drag-and-drop"
            d="M6.171,5c-.015,0-.027.009-.041.009a.5.5,0,0,0-.059,0,.95.95,0,0,0-.117.032,1.226,1.226,0,0,0-.281.073,1.145,1.145,0,0,0-.169.112,1.09,1.09,0,0,0-.188.146,1,1,0,0,0-.1.135,1.086,1.086,0,0,0-.139.242,1.141,1.141,0,0,0-.034.167A1.05,1.05,0,0,0,5,6.134V10.89a1.171,1.171,0,0,0,2.341,0V7.341h4.72a1.171,1.171,0,0,0,0-2.341H6.274c-.027,0-.053,0-.08,0C6.185,5,6.179,5,6.171,5Zm10.5,0a1.171,1.171,0,0,0,0,2.341h2.415a1.171,1.171,0,0,0,0-2.341ZM23.7,5a1.171,1.171,0,0,0,0,2.341H26.11A1.171,1.171,0,0,0,26.11,5ZM30.72,5a1.171,1.171,0,0,0,0,2.341h2.415a1.171,1.171,0,0,0,0-2.341Zm7.024,0a1.171,1.171,0,0,0,0,2.341h4.719V10.89a1.171,1.171,0,0,0,2.341,0V6.134a1.013,1.013,0,0,0-.046-.213,1.171,1.171,0,0,0-.034-.169,1.071,1.071,0,0,0-.139-.24,1.251,1.251,0,0,0-.1-.137,1.107,1.107,0,0,0-.19-.146,1.01,1.01,0,0,0-.169-.112,1.222,1.222,0,0,0-.279-.073.95.95,0,0,0-.117-.032.5.5,0,0,0-.059,0c-.014,0-.026-.009-.041-.009s-.015,0-.023,0c-.027,0-.053,0-.08,0ZM6.171,14.366A1.157,1.157,0,0,0,5,15.5v2.415a1.171,1.171,0,0,0,2.341,0V15.5A1.157,1.157,0,0,0,6.171,14.366Zm37.463,0A1.157,1.157,0,0,0,42.463,15.5v2.415a1.171,1.171,0,0,0,2.341,0V15.5A1.157,1.157,0,0,0,43.634,14.366ZM6.171,21.39A1.157,1.157,0,0,0,5,22.524v2.415a1.171,1.171,0,0,0,2.341,0V22.524A1.157,1.157,0,0,0,6.171,21.39Zm14.049,0a4.7,4.7,0,0,0-4.683,4.683V48.317A4.7,4.7,0,0,0,20.22,53h28.1A4.7,4.7,0,0,0,53,48.317V26.073a4.7,4.7,0,0,0-4.683-4.683Zm0,2.341h28.1a2.324,2.324,0,0,1,2.341,2.341V48.317a2.324,2.324,0,0,1-2.341,2.341H20.22a2.324,2.324,0,0,1-2.341-2.341V26.073A2.324,2.324,0,0,1,20.22,23.732ZM6.171,28.415A1.157,1.157,0,0,0,5,29.549v2.415a1.171,1.171,0,0,0,2.341,0V29.549A1.157,1.157,0,0,0,6.171,28.415Zm25.756,2.341V42.463l2.833-2.41,1.781,4.166,1.5-.665-1.884-4.1,3.965-.5ZM6.171,35.439A1.156,1.156,0,0,0,5,36.573V41.19c0,.027,0,.053,0,.08,0,.008,0,.015,0,.023s.009.027.009.041a.5.5,0,0,0,0,.059.95.95,0,0,0,.032.117,1.222,1.222,0,0,0,.073.279,1.01,1.01,0,0,0,.112.169,1.107,1.107,0,0,0,.146.19,1.251,1.251,0,0,0,.137.1,1.071,1.071,0,0,0,.24.139,1.17,1.17,0,0,0,.169.034,1.013,1.013,0,0,0,.213.046h5.927a1.171,1.171,0,0,0,0-2.341H7.341V36.573A1.156,1.156,0,0,0,6.171,35.439Z"
            transform="translate(-5 -5)"
          />
        </svg>
        <p class="mt-2" v-html="$t('please_drag_list_to_import')" />
      </div>
    </div>
    <div
      v-for="(file, index) in files"
      :key="`key-${index}`"
      class="file"
      :class="{ completed: progress[index].done }"
    >
      <div>
        <p class="file-name">{{ file.name }}</p>
        <font-awesome-icon
          v-if="progress[index].timeLeft === 0"
          :icon="['far', 'times-circle']"
          @click="() => removeFile(index)"
          style="color: #157efb"
        />
      </div>
      <progress-bar
        v-if="progress[index].start"
        :percentage="progress[index].percentage"
        :timeLeft="progress[index].timeLeft"
        :failed="progress[index].failed"
        :done="progress[index].done"
      />
      <div v-else class="flex text-left">
        <core-button
          class="mr-2"
          type="coolrunner_outline"
          @click="() => removeFile(index)"
          >{{ $t("remove") }}</core-button
        >
        <core-button type="coolrunner" @click="() => uploadFile(file, index)">{{
          $t("upload")
        }}</core-button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../../utils/eventbus";
import ProgressBar from "./ProgressBar";

export default {
  components: { ProgressBar },
  data: () => {
    return {
      files: [],
      progress: []
    };
  },
  mounted: function() {
    EventBus.$on("TRIGGER_UPLOAD_WINDOW", () =>
      this.$refs["file-input"]?.click()
    );
    EventBus.$on("TRIGGER_UPLOAD_ALL_FILES", () => this.uploadFiles());
  },
  watch: {
    files: function(value) {
      EventBus.$emit("HAS_FILES", !!value.length);
    },
    isUploading: function(val) {
      this.$emit("update:uploading", val);
    },
    isSuccessfully: function(val) {
      if (val) this.$emit("success");
    }
  },
  computed: {
    isUploading: function() {
      return this.$_.some(this.progress, p => p.percentage !== 100);
    },
    isFailed: function() {
      return this.$_.some(this.progress, p => p.failed);
    },
    isSuccessfully: function() {
      return (
        !!this.progress.length && this.$_.every(this.progress, p => p.done)
      );
    }
  },
  methods: {
    removeFile(fileKey) {
      let files = [...this.files];
      let progress = [...this.progress];
      progress.splice(fileKey, 1);
      files.splice(fileKey, 1);
      this.files = files;
      this.progress = progress;
    },
    handleFileInput(e) {
      let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
      if (!files) return;

      let fs = [...this.files];
      let progress = [...this.progress];

      [...files].forEach(f => {
        fs.push(f);
        progress.push({ percentage: 0, timeLeft: undefined });
      });

      this.files = fs;
      this.progress = progress;

      this.$refs.form.reset();
    },
    handleProgress: function(i) {
      return e => {
        let progress = [...this.progress];
        let percentCompleted = Math.round((e.loaded * 100) / e.total);
        let duration = (new Date().getTime() - progress[i].start) / 1000;
        let bps = e.loaded / duration;
        let timeLeft = (e.total - e.loaded) / bps;

        const fileProgress = {
          ...progress[i],
          bps,
          timeLeft,
          total: e.total,
          percentage: percentCompleted
        };
        progress[i] = fileProgress;
        this.progress = progress;
      };
    },
    handleError: function(i) {
      let progress = [...this.progress];

      const fileProgress = {
        ...progress[i],
        failed: true
      };
      progress[i] = fileProgress;
      this.progress = progress;
    },
    uploadFiles: function() {
      this.$_.each(this.files, (f, i) => {
        this.uploadFile(f, i);
      });
    },
    uploadFile: function(f, i) {
      if (this.progress[i]?.start) {
        return;
      }
      let data = new FormData();

      let progress = [...this.progress];

      const fileProgress = {
        ...progress[i],
        name: f.name,
        failed: false,
        done: false,
        start: new Date().getTime()
      };
      progress[i] = fileProgress;
      this.progress = progress;

      data.append(`file`, f);
      const config = {
        onUploadProgress: this.handleProgress(i)
      };

      this.$upload("import/upload", data, undefined, config)
        .then(() => {
          this.$notification({
            title: this.$t("entity_imported", { entity: this.$t("file") }),
            text: this.$t("file_imported_correctly", {
              file: f.name,
              tab: this.$t("loaded_multiple")
            })
          });

          let progress = [...this.progress];

          const fileProgress = {
            ...progress[i],
            done: true
          };
          progress[i] = fileProgress;
          this.progress = progress;
        })
        .catch(err => this.handleError(i));
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-drop-container {
  height: 100%;
  background: white;
  padding: 30px;
}
.file-upload-wrapper {
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 2px dashed #8494b4;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  form {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  input {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    cursor: pointer;
    opacity: 0;
    filter: alpha(opacity=0);
  }
  svg {
    fill: #8494b4;
  }
  p {
    color: #8494b4;
    font-size: 28px;
  }
}

.file {
  height: 135px;
  padding: 24px 30px;
  background-color: white;
  border-radius: 8px;
  opacity: 1;
  transition: opacity 250ms linear;
  border: 2px solid #e3e7ed;
  background: rgb(227 231 237 / 20%);

  &:not(:first-of-type) {
    margin-top: 10px;
  }
  > div:first-of-type {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  svg {
    font-size: 20px;
    cursor: pointer;
  }
  &-name {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
